import { render, staticRenderFns } from "./WhatsPrintComponent.vue?vue&type=template&id=747c1d31&scoped=true&"
import script from "./WhatsPrintComponent.vue?vue&type=script&lang=ts&"
export * from "./WhatsPrintComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WhatsPrintComponent.vue?vue&type=style&index=0&id=747c1d31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c1d31",
  null
  
)

export default component.exports